import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import { canEditStockReceipt } from '#/modules/imsMgmt/receipts/shared/receiptStatus';
import { canEditStockIssue } from '#/modules/imsMgmt/receipts/stockIssue/helper/issueStatus';

import WorkOrderRelatedDocPreviewDialog from './WorkOrderRelatedDocPreviewDialog';

/**
 * 工單出庫／入庫歷史列：開預覽 Dialog（審核在 Dialog 內完成）。
 * 出庫／入庫草稿另提供「編輯」。
 */
const WorkOrderRelatedDocActionsCell = ({
  row,
  variant,
  workOrderId,
  onMutated,
}) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const docId = row?.id;
  const isIssue = variant === 'stockIssue';
  const showEdit = Boolean(workOrderId)
    && Boolean(docId)
    && (isIssue
      ? canEditStockIssue(row?.status)
      : canEditStockReceipt(row?.status));
  const editPath = isIssue
    ? ROUTES.workOrderOutboundEdit(workOrderId, docId)
    : ROUTES.workOrderInboundEdit(workOrderId, docId);

  if (!workOrderId || !docId) {
    return <span className="text-muted-foreground">—</span>;
  }

  return (
    <>
      <div className="flex items-center gap-2 whitespace-nowrap">
        <Button type="button" size="sm" onClick={() => setPreviewOpen(true)}>
          預覽
        </Button>
        {showEdit ? (
          <Button type="button" size="sm" variant="outline" asChild>
            <Link to={editPath}>
              編輯
            </Link>
          </Button>
        ) : null}
      </div>
      <WorkOrderRelatedDocPreviewDialog
        open={previewOpen}
        onOpenChange={setPreviewOpen}
        variant={variant}
        workOrderId={workOrderId}
        docId={docId}
        onMutated={onMutated}
      />
    </>
  );
};

WorkOrderRelatedDocActionsCell.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
  variant: PropTypes.oneOf(['stockIssue', 'stockReceipt']).isRequired,
  workOrderId: PropTypes.string.isRequired,
  onMutated: PropTypes.func,
};

export default WorkOrderRelatedDocActionsCell;
